
import { mapGetters } from 'vuex'
import TopBanner from './plp-content/topBanner.vue'
import RelatedCategories from './relatedCategories.vue'
import { parseBreadcrumbs } from '~/helpers/shopify/breadcrumbs'

export default {
  components: {
    TopBanner,
    RelatedCategories,
  },
  computed: {
    ...mapGetters({
      vxBreadcrumbs: 'common/getBreadcrumbs',
    }),
    collectionSlug() {
      return this.$route.params.handle
    },
    breadcrumbs() {
      if (!this.vxBreadcrumbs) return []
      return parseBreadcrumbs(
        [this.collectionSlug],
        this.vxBreadcrumbs,
        this.$i18n.locale
      )
    },
    level1() {
      return this.breadcrumbs?.[0] || null
    },
    level2() {
      return this.breadcrumbs?.[1] || null
    },
    level3() {
      return this.breadcrumbs?.[2] || null
    },
    relatedCategories() {
      const offset = this.breadcrumbs?.length === 3 ? 2 : 1
      const parentCategory = this.breadcrumbs[this.breadcrumbs.length - offset]
      const breadcrumbsFlat = Object.values(this.vxBreadcrumbs?.flat)

      if (breadcrumbsFlat) {
        const matchedCategories = breadcrumbsFlat.filter(
          (breadcrumb) =>
            breadcrumb.includes(parentCategory?.slug) &&
            breadcrumb.length > this.breadcrumbs.length
        )

        if (matchedCategories?.length) {
          return this.parseRelatedCategories(matchedCategories)
        }
      }
      return []
    },
    labelsLocale() {
      switch (this.$i18n.locale) {
        case 'en-ca':
        case 'en-us':
        case 'en-eu':
          return 'en_US'
        case 'fr-ca':
          return 'fr_CA'
        case 'fr-eu':
          return 'fr_FR'
        default:
          return 'en_US'
      }
    },
  },
  methods: {
    parseRelatedCategories(matchedCategories) {
      const parsedCategories = []
      for (const cat of matchedCategories) {
        const matchedCat = cat?.[0]
        parsedCategories.push({
          slug: `${matchedCat}`,
          label:
            this.vxBreadcrumbs?.labelsObj?.[matchedCat]?.[this.labelsLocale],
        })
      }

      return parsedCategories
    },
  },
}
